var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 31C62 48.125 48 62 31 62C13.875 62 0 48.125 0 31C0 14 13.875 0 31 0C48 0 62 14 62 31ZM27.375 47.5L50.375 24.5C51.125 23.75 51.125 22.375 50.375 21.625L47.5 18.875C46.75 18 45.5 18 44.75 18.875L26 37.625L17.125 28.875C16.375 28 15.125 28 14.375 28.875L11.5 31.625C10.75 32.375 10.75 33.75 11.5 34.5L24.5 47.5C25.25 48.25 26.625 48.25 27.375 47.5Z",
    fill: "#057C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.1ddfd1cad19184a1693e5d745f0c7fb2.svg";
export { ForwardRef as ReactComponent };